import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ErrorFill from 'yoda-core-components/lib/assets/svg/errorFill.svg';

export class ProductOptionsErrorBanner extends Component {
    static defaultProps = {
        errorBannerMessage: '',
        fromMiniPDP: false,
    };

    static propTypes = {
        fromMiniPDP: PropTypes.bool,
        errorBannerMessage: PropTypes.string,
    };

    render() {
        const { fromMiniPDP, errorBannerMessage } = this.props;
        const ErrorCapitalize =
            errorBannerMessage.charAt(0).toUpperCase() + errorBannerMessage.slice(1);
        return (
            errorBannerMessage && (
                <div className={`productErrorBannner ${dt(['!p-0'])}`}>
                    <div
                        className={[
                            dt([
                                'flex',
                                'items-start',
                                'gap-2',
                                !fromMiniPDP && 'lg:w-[396px]',
                                'bg-[#FFE5E5]',
                                'border-l-4',
                                'border-[#c00]',
                                'border-solid',
                                'text-black',
                                'p-3',
                            ]),
                        ].join(' ')}
                        role="alert"
                    >
                        <div className={dt(['shrink-0'])}>
                            <Icon
                                iconType="svg"
                                automationId="product-options-error-icon"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                            >
                                <ErrorFill />
                            </Icon>
                        </div>
                        <p>{ErrorCapitalize}</p>
                    </div>
                </div>
            )
        );
    }
}

export default ProductOptionsErrorBanner;
